export default {
  INSERT_INTO_ALL: "INSERT_INTO_ALL_MARKETING_COMMODITIES",
  ADD_TO_IN_PROGRESS: "ADD_TO_IN_PROGRESS_MARKETING_COMMODITIES",
  REMOVE_FROM_IN_PROGRESS: "REMOVE_FROM_IN_PROGRESS_MARKETING_COMMODITIES",
  INSERT_INTO_FORMS: "INSERT_INTO_FORMS_MARKETING_COMMODITIES",
  DESTROY_FORM: "DESTROY_FORM_MARKETING_COMMODITIES",
  SET_FORM_ERROR: "SET_FORM_ERROR_MARKETING_COMMODITIES",
  UPDATE_FORM_INSTANCE: "UPDATE_FORM_INSTANCE_MARKETING_COMMODITIES",
  INSERT_INTO_PAGINATION: "INSERT_INTO_PAGINATION_MARKETING_COMMODITIES",
  INSERT_INTO_FILTERED: "INSERT_INTO_FILTERED_MARKETING_COMMODITIES",
  RESET_STATE: "RESET_STATE_MARKETING_COMMODITIES",
  SET_ASK_DELETE_DATA: "SET_ASK_DELETE_DATA_MARKETING_COMMODITIES",
  REMOVE_OBJECT: "REMOVE_OBJECT_MARKETING_COMMODITIES",
  CLEAR_FETCHED: "CLEAR_FETCHED_MARKETING_COMMODITIES",

  ADD_MULTIPLE_APARTMENTS: "ADD_MULTIPLE_APARTMENTS_APARTMENT_COMMODITIES",
  ADD_APARTMENT: "ADD_APARTMENT_APARTMENT_COMMODITIES",
  REMOVE_APARTMENT: "REMOVE_APARTMENT_APARTMENT_COMMODITIES",
  SET_COMMODITIES: "SET_COMMODITIES_APARTMENT_COMMODITIES",
  SET_DEFAULT_SETTINGS: "SET_DEFAULT_SETTINGS_APARTMENT_COMMODITIES",

  LIST_URL: "/market/ads/apartmentcommodities/list/",
  POST_URL: "/market/ads/apartmentcommodities/",
  PATCH_URL: "/market/ads/apartmentcommodities/",
  GET_URL: "/market/ads/apartmentcommodities/",

  STORE_NAME: "marketApartmentCommodities",
};
